import { ValidationError } from './ValidationError';

export class ValidationErrors {
  errors: ValidationError[] = [];

  constructor(errors: ValidationError[]) {
    this.errors = errors;
  }

  clear() {
    this.errors = [];
  }

  hasAny(): boolean {
    return this.errors.length > 0;
  }

  has(fieldId: string): boolean {
    return this.errors.find((e) => e.fieldId === fieldId) !== undefined;
  }

  first(): ValidationError | null {
    if (this.errors.length === 0) return null;
    return this.errors[0];
  }

  message(fieldId: string): string | null {
    const error = this.errors.find((e) => e.fieldId === fieldId);
    return error === undefined ? null : error.message;
  }
}
